/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { AxiosResponse } from "axios";
import { 
    ThunkResult } from "./actionResultTypes";
import { 
    Action as ProjectPersonalAction,
    ActionType as ProjectPersonalActionType, 
    IFetchProjectPersonals,
    IFetchProjectPersonalsSuccess,
    IFetchProjectPersonalsFail,
    IEditProjectPersonal,
    IEditProjectPersonalSuccess,
    IEditProjectPersonalFail,
    IDeleteProjectPersonal,
    IDeleteProjectPersonalSuccess,
    IDeleteProjectPersonalFail,
    IAddProjectPersonal,
    IAddProjectPersonalSuccess,
    IAddProjectPersonalFail,
    IFetchProjectPersonalsReportSuccess,
    IFetchProjectPersonalsReportFail,
} from "../actionTypes/projectPersonalActionTypes";
import { toastError, 
     toastSuccess 
} from '../../services/toasters';
import { 
    IProjectPersonal as ProjectPersonal, 
    IRequestProjectPersonal,
    IProjectPersonalReport,
} from '../../models/projectPersonal';

import { httpGenerator } from '../../services';
import { MultiResponseType } from '../../models/multiResponseType';
import { IRequestReadReport } from '../../models/reportVisit';


export const GetProjectPersonal = (request: IRequestReadReport): ThunkResult<void> => async (dispatch: Dispatch<ProjectPersonalAction>) => { 
    dispatch<IFetchProjectPersonals>({  
        type: ProjectPersonalActionType.FETCH_PROJECTPERSONALS
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<ProjectPersonal>> = await httpGenerator(authToken!).post(`projectPersonals/contractMonthList/`, request);
        dispatch<IFetchProjectPersonalsSuccess>({
            type: ProjectPersonalActionType.FETCH_PROJECTPERSONALS_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchProjectPersonalsFail>({
            type: ProjectPersonalActionType.FETCH_PROJECTPERSONALS_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const GetProjectPersonalReport = (contractId: number, dateId: number): ThunkResult<void> => async (dispatch: Dispatch<ProjectPersonalAction>) => { 
    dispatch<IFetchProjectPersonals>({  
        type: ProjectPersonalActionType.FETCH_PROJECTPERSONALS
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<IProjectPersonalReport>> = await httpGenerator(authToken!).get(`projectPersonals/contractMonthReportList/${contractId}/${dateId}`);
        dispatch<IFetchProjectPersonalsReportSuccess>({
            type: ProjectPersonalActionType.FETCH_PROJECTPERSONALSREPORT_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchProjectPersonalsReportFail>({
            type: ProjectPersonalActionType.FETCH_PROJECTPERSONALSREPORT_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const AddProjectPersonal = (request: IRequestProjectPersonal): ThunkResult<void> => async (dispatch: Dispatch<ProjectPersonalAction>) => {
    dispatch<IAddProjectPersonal>({ 
        type: ProjectPersonalActionType.ADD_PROJECTPERSONAL
    });
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<ProjectPersonal> = await httpGenerator(authToken!).post(`projectPersonals/`, request);
        dispatch<IAddProjectPersonalSuccess>({
            type: ProjectPersonalActionType.ADD_PROJECTPERSONAL_SUCCESS,
            payload: response.data  
        });
        toastSuccess("اطلاعات جدید با موفقیت ذخیره گردید");

    } catch(err:any) {
        dispatch<IAddProjectPersonalFail>({
            type: ProjectPersonalActionType.ADD_PROJECTPERSONAL_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در ذخیره سازی اطلاعات جدید");
    }
};

export const EditProjectPersonal = (id: number, request: IRequestProjectPersonal): ThunkResult<void> => async (dispatch: Dispatch<ProjectPersonalAction>) => { 
    dispatch<IEditProjectPersonal>({ 
        type: ProjectPersonalActionType.EDIT_PROJECTPERSONAL 
    });
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<ProjectPersonal> = await httpGenerator(authToken!).put(`projectPersonals/${id}/`, request);
        dispatch<IEditProjectPersonalSuccess>({ 
            type: ProjectPersonalActionType.EDIT_PROJECTPERSONAL_SUCCESS, 
            payload: response.data
        });
        toastSuccess("اطلاعات مورد نظر با موفقیت ویرایش گردید");

    } catch (err: any) {
        dispatch<IEditProjectPersonalFail>({ 
            type: ProjectPersonalActionType.EDIT_PROJECTPERSONAL_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در ویرایش اطلاعات مورد نظر");
    }
};

export const DeleteProjectPersonal = (deletedId: number): ThunkResult<void> => async (dispatch: Dispatch<ProjectPersonalAction>) => { 
    dispatch<IDeleteProjectPersonal>({ type: ProjectPersonalActionType.DELETE_PROJECTPERSONAL });
    try {
        const authToken = sessionStorage.getItem("token")
        await httpGenerator(authToken!).delete(`projectPersonals/${deletedId}/`);
        dispatch<IDeleteProjectPersonalSuccess>({
            type: ProjectPersonalActionType.DELETE_PROJECTPERSONAL_SUCCESS,
            payload: deletedId
        });
        toastSuccess("اطلاعات مورد نظر با موفقیت حذف گردید");

    } catch (err: any) {
        dispatch<IDeleteProjectPersonalFail>({ 
            type: ProjectPersonalActionType.DELETE_PROJECTPERSONAL_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در خذف اطلاعات مورد نظر");
    }
};